// extracted by mini-css-extract-plugin
export default {"reviews":"Reviews_reviews__QjehG","reviewsTitle":"Reviews_reviewsTitle__zCyuZ","reviewsList":"Reviews_reviewsList__aGCq3"};